import { useDraggable, useDroppable } from '@dnd-kit/core';
import classNames from 'classnames';
import { shouldTruncateCategoryName } from '../../helpers/menuGroupEdit';
import menuGroupEditStore from '../../store/menuGroupEditStore';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { getTranslate } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { IMenuGroupCategory } from 'src/view/screens/MenuManagementScreen/screens/MenuGroupsScreen/types/menuGroups';
import './style.scss';

interface IProps {
  id: number;
  index: number;
  category: IMenuGroupCategory;
  className?: string;
  isSelected: boolean;
}

const DraggableCategory = (props: IProps): JSX.Element => {
  const { attributes, isDragging, listeners, setNodeRef: draggableRef } = useDraggable({ id: props.id.toString() });
  const { isOver, setNodeRef: droppableRef } = useDroppable({ id: props.id.toString() });

  const selectCategory = () => {
    menuGroupEditStore.setSelectedCategoryId(props.category.id);
  };

  const excludeCategory = () => {
    menuGroupEditStore.excludeCategory(props.category.id, props.index);
  };

  const wrapperClassName = classNames('draggable-category', props.className, {
    'draggable-category_selected': props.isSelected,
    'draggable-category_droppable': isOver && props.id === props.category.id,
  });
  const titleClassName = classNames('draggable-category__title', { truncated: shouldTruncateCategoryName(getTranslate(props.category.name)) });

  return (
    <div className={wrapperClassName} ref={isDragging ? draggableRef : droppableRef}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <div className="draggable-category__control pr-3 pl-4 cursor-grab" {...listeners} {...attributes}>
        <Icon name={Icons.DragHand} size={14} className="color-gray2" />
      </div>

      <div className="d-flex align-items-center full-width justify-content-center" onClick={selectCategory}>
        <p className={titleClassName}>{getTranslate(props.category.name)}</p>
      </div>

      <div className="draggable-category__control pr-4 pl-3" onClick={excludeCategory}>
        <Icon name={Icons.Close} size={14} className="color-gray2" />
      </div>
    </div>
  );
};

export default DraggableCategory;
